export default __webpack_public_path__ + "static/media/information--lane-control-multiple-lanes--g1.ea69ae2c.png";